import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Store } from '@ngrx/store'
import { Observable, of } from 'rxjs'
import { filter, switchMap, tap } from 'rxjs/operators'
import { setProject } from '../../store/stage/stage.actions'
import { getProject } from '../../store/stage/stage.selectors'
import { AppState } from '../../store/storage'

@Injectable({ providedIn: 'root' })
export class AppIsLumpSumGuard  {
   constructor(
      private _router: Router,
      private _state: Store<AppState>
   ) {}
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const projectId = Number(route.paramMap.get('projectId'))

      return this._state.select(getProject).pipe(
         tap((project) => {
            // dispatch setProject if the project is not loaded yet
            if (!project && projectId) {
               this._state.dispatch(setProject({ projectId }))
            }
         }),
         filter((project) => !!project && project.id === projectId),
         switchMap((project) => {
            if (!project?.lumpSum) {
               return of(this._router.createUrlTree([`${projectId}/dashboard`]))
            }
            return of(true)
         })
      )
   }
}

@Injectable({ providedIn: 'root' })
export class AppIsActualCostGuard  {
   constructor(
      private _router: Router,
      private _state: Store<AppState>
   ) {}
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const projectId = Number(route.paramMap.get('projectId'))

      return this._state.select(getProject).pipe(
         tap((project) => {
            if (!project && projectId) {
               this._state.dispatch(setProject({ projectId }))
            }
         }),
         filter((project) => !!project && project.id === projectId),
         switchMap((project) => {
            if (project?.lumpSum) {
               return of(this._router.createUrlTree([`${projectId}/dashboard`]))
            }
            return of(true)
         })
      )
   }
}

@Injectable({ providedIn: 'root' })
export class AppIsUserCanEditLumpSumGuard  {
   constructor(
      private _router: Router,
      private _state: Store<AppState>
   ) {}
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const projectId = Number(route.paramMap.get('projectId'))

      return this._state.select(getProject).pipe(
         tap((project) => {
            // dispatch setProject if the project is not loaded yet
            if (!project && projectId) {
               this._state.dispatch(setProject({ projectId }))
            }
         }),
         filter((project) => !!project && project.id === projectId),
         switchMap((project) => {
            if (project?.permission.type !== 'WRITE') {
               return of(this._router.createUrlTree([`${projectId}/dashboard`]))
            }
            return of(true)
         })
      )
   }
}
